import {
    ActionFunction,
    redirect
} from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { parseFormData } from "../../utils/parseFormData";


export const cityAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    const updates = parseFormData(formData);
    if (params.cityCode === "new")
        await axiosApi.post("/api/cities", updates);
    else await axiosApi.put("/api/cities", { ...updates, cityCode: params.cityCode });
    return redirect(`/cities`);
}